import React, { Fragment, ReactNode } from 'react';
import { Query } from '@apollo/client/react/components';

import { LedgerQuery } from './queries';
import { InternalRefetchQueryDescriptor } from '@apollo/client';
import { LedgerAccount } from './types';

type LedgerInfoContainerProps = {
  ledgerId: string;
  clientId: string;
  children: (
    loading: boolean,
    error: string,
    ledgerInfo: LedgerAccount,
    refetchQueries: InternalRefetchQueryDescriptor[],
  ) => ReactNode;
};

const LedgerInfoContainer = ({ ledgerId, clientId, children }: LedgerInfoContainerProps) => (
  <Query query={LedgerQuery} variables={{ clientId }}>
    {({ loading, error, data }: any) => {
      const ledgerAccounts = data?.ledgerAccounts;
      const ledgerInfo = ledgerAccounts && ledgerAccounts.find(ledger => ledger.id === ledgerId);
      const refetchQueries = [{ query: LedgerQuery, variables: { clientId } }];

      return <Fragment>{children(loading, error, ledgerInfo, refetchQueries)}</Fragment>;
    }}
  </Query>
);

LedgerInfoContainer.defaultProps = {
  ledgerCodes: [],
  ledgerIds: [],
};

export default LedgerInfoContainer;
